<app-navbar class="navbar" (setTranslationEvent)="setTranslation($event)" [strings]="strings"></app-navbar>

<div class="banner-about">
  <app-empty-tag class="three-tag"></app-empty-tag>
  <p>
    {{strings.bannerAbout}}
  </p>

  <div class="banner-buttons">
    <a href="#about">{{strings.aboutMe}}</a>
    <button type="button" (click)="showContactForm()">{{strings.contactMe}}</button>
  </div>
</div>
<!-- PARALLAX -->
<h1 appParallax [ratio]="-0.22" class="name-title">
AMIR KASUMOVIĆ
</h1>

<div class="content-container">

  <!-- ABOUT ME -->
  <app-about [strings]="strings"></app-about>

  <!-- PORTFOLIO -->
  <app-work [strings]="strings"></app-work>

  <!-- SKILLS -->
  <app-skills [strings]="strings"></app-skills>

  <!-- EXPERIENCE -->
  <app-experience (viewExperienceEvent)="showExperience($event)" [strings]="strings"></app-experience>

  <!-- EDUCATION -->
  <app-education [strings]="strings"></app-education>

  <!-- CERTIFICATES -->
  <app-certificates (viewCertificateEvent)="showCertificate($event)" [strings]="strings"></app-certificates>

  <!-- FOOTER -->
  <app-footer (setTranslationEvent)="setTranslation($event)" [strings]="strings"></app-footer>
</div>


<!-- MODALS -->
<div class="blur"></div>
<div class="light-blur"></div>

<!-- EXPERIENCE MODAL -->
<div class="modal experience" id="experienceModal">
  <button type="button" class="close-btn" (click)="hideExperience()">X</button>
  <div class="experience-content-wrapper" id="experienceContentWrapper">
    <div class="experience-company-info">
      <div class="experience-company-title">
        <h1>{{experience.title}}</h1>
        <p><strong>{{experience.company}}</strong>, {{experience.details.location}}</p>
      </div>
      <div class="experience-view-company">
        <p>{{experience.from}} - {{experience.to}}</p>
        <a [href]="experience.details.link" target="_blank">{{strings.experienceViewCompanyButton}}</a>
      </div>
    </div>

    <h2>{{strings.experienceJobDescription}}</h2>
    <p class="experience-description">{{experience.details.description}}</p>

    <h2>{{strings.experienceResponsibilities}}</h2>
    <ul class="experience-responsibilities">
      <li *ngFor="let responsibility of experience.details.responsibilities">{{responsibility}}</li>
    </ul>
  </div>

</div>

<!-- CERTIFICATE MODAL -->
<div class="modal" id="certificateModal">
  <button type="button" class="close-btn" (click)="hideCertificate()">X</button>
  <img class="certificate-image" src="" alt="Amir Kasumovic certificate">
</div>

<button type="button" class="contact-me-btn" (click)="showContactForm()">{{strings.contactMe}}</button>

<!-- CONTACT -->
<div class="contact-form">
  <button class="contact-form-close-btn" (click)="hideContactForm()">x</button>
  <form
    action="https://formspree.io/f/myyldape"
    method="POST">
    <h2>{{strings.contactFormTitle}}</h2>
    <label>
      {{strings.contactFormEmail}}
      <input type="email" name="email" required>
    </label>
    <label>
      {{strings.contactFormName}}
      <input type="text" name="name" required>
    </label>
    <label class="message-label">
      {{strings.contactFormMessage}}
      <textarea name="message" required></textarea>
    </label>
    <!-- your other form fields go here -->
    <button type="submit">{{strings.contactFormSendButton}}</button>
  </form>
</div>
